import catalogVector from "../../assets/images/catalog_vector.png";
import historyVector from "../../assets/images/history_vector.png";
import readingOnlineVector from "../../assets/images/reading_online_vector.png";
import readingVector from "../../assets/images/reading_vector.png";
import "./ourServices.css";
import { translate } from "../../app/utils";

const OurServices = () => {
  const handleNavigate = () => {
    window.location.replace("/aboutUs");
  };
  return (
    <section className="library-services-section">
      <div className="services-list">
        <div className="service-card" onClick={handleNavigate}>
          <img src={readingVector} alt="" />
          <h2>{translate("personalReadingArea")}</h2>
          <p>
            {translate("personalReadingAreaDescription")}
          </p>
        </div>
        <div className="service-card" onClick={handleNavigate}>
          <img src={historyVector} alt="" />
          <h2>{translate("extractionOfHistoricData")}</h2>
          <p>
            {translate("extractionOfHistoricDataDescription")}
          </p>
        </div>
        <div className="service-card" onClick={handleNavigate}>
          <img src={readingOnlineVector} alt="" />
          <h2>{translate("onlineAndPhysicalReadingMaterial")}</h2>
          <p>
            {translate("onlineAndPhysicalReadingMaterialDescription")}
          </p>
        </div>
        <div className="service-card" onClick={handleNavigate}>
          <img src={catalogVector} alt="" />
          <h2>{translate("comprehensiveCatalog")}</h2>
          <p>
            {translate("comprehensiveCatalogDescription")}
          </p>
        </div>
      </div>
    </section>
  );
};

export default OurServices;
